import React from "react";
import SurveyList from "./surveyList";

class SurveyListParent extends React.Component {
    render() {
        return <SurveyList />;
    }
}
export default SurveyListParent;
